import { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { supabase } from './supabaseClient';

export function LastSeenTracker() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const updateLastSeen = async () => {
      try {
        await supabase.rpc('update_last_seen');
      } catch (error) {
        console.error('Error updating last seen:', error);
      }
    };

    updateLastSeen();

    const interval = setInterval(updateLastSeen, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user]);

  return null;
}
